import { render, staticRenderFns } from "./Comp5t3.vue?vue&type=template&id=065b4785&scoped=true&"
import script from "./Comp5t3.vue?vue&type=script&lang=js&"
export * from "./Comp5t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp5t3.vue?vue&type=style&index=0&id=065b4785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b4785",
  null
  
)

export default component.exports